import React, { Fragment } from 'react'
import useStyles from './styles'
import { Box, Typography } from '@material-ui/core'
import { HeaderImage } from 'components/ItemDetails/Image'
import classnames from 'clsx'
import useNameStyle from 'hooks/useNameStyle'
import { useMemo } from 'react'

const ItemAction = ({ data, item }) => {
  const classes = useStyles()
  let nameStyle = useNameStyle(
    item && item.high_bid_data ? item.high_bid_data.high_bid_user_name : ''
  )
  if (item !== undefined) {
    if (
      item.high_bid_data.high_bid_anon === '1' ||
      item.high_bid_data.high_bid_anon === 1
    ) {
      nameStyle = 'Anonymous'
    } else {
      //nameStyle = useNameStyle(item.high_bid_data.high_bid_user_name)
    }
  }
  const styledName = useMemo(() => {
    if (
      item &&
      item.high_bid_data &&
      (item.high_bid_data.high_bid_anon === '1' ||
        item.high_bid_data.high_bid_anon === 1)
    ) {
      return 'Anonymous'
    }
    if (nameStyle === 'paddle_number') {
      if (item.high_bid_data.paddle_number) {
        return item.high_bid_data.paddle_number
      } else if (item.high_bid_data.high_bid_user_phone) {
        return item.high_bid_data.high_bid_user_phone.substr(
          item.high_bid_data.high_bid_user_phone.length - 4
        )
      } else {
        return 'Anonymous'
      }
    } else {
      return nameStyle
    }
  }, [nameStyle])

  if (item !== undefined) {
    return (
      <Box
        display="flex"
        className={classnames(classes.itemAction, {
          [classes.itemActionClosed]: data.status === 2
        })}
      >
        {item.image && item.image.length > 0 && (
          <Box flexGrow="0" flexShrink="0" className={classes.imageBox}>
            <HeaderImage image={item.image[0]} />
          </Box>
        )}
        <Box className={classes.textBox}>
          {data.status === 2 && (
            <Fragment>
              {item.item_type === 'auction' && (
                <Typography variant="h2" className={classes.winnerText}>
                  {styledName} is the Winner!
                </Typography>
              )}
              {item.item_type !== 'auction' && (
                <Typography variant="h2" className={classes.winnerText}>
                  Item Closed
                </Typography>
              )}
            </Fragment>
          )}
          {data.status === 1 && (
            <Typography variant="h2" className={classes.itemOpenText}>
              New item open!
            </Typography>
          )}
          <Typography variant="h2" className={classes.itemTitle}>
            {item.name}
          </Typography>
        </Box>
      </Box>
    )
  } else {
    return <Box />
  }
}
export default ItemAction



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/ItemAction/index.jsx